import {
  HouseholdChatPromptTemplate,
  NoDocumentsOnboardingPromptType,
} from '@/types/schema';

export type PropertyLaw = 'common law' | 'community property';

const noDocumentsPromptToChatTemplate: Record<
  NoDocumentsOnboardingPromptType,
  HouseholdChatPromptTemplate
> = {
  [NoDocumentsOnboardingPromptType.AbJointTrust]:
    HouseholdChatPromptTemplate.AbJointTrust,
  [NoDocumentsOnboardingPromptType.AbSeparateTrusts]:
    HouseholdChatPromptTemplate.AbSeparateTrusts,
  [NoDocumentsOnboardingPromptType.AbcJointTrust]:
    HouseholdChatPromptTemplate.AbcJointTrust,
  [NoDocumentsOnboardingPromptType.AbcSeparateTrusts]:
    HouseholdChatPromptTemplate.AbcSeparateTrusts,
  [NoDocumentsOnboardingPromptType.EqualShares]:
    HouseholdChatPromptTemplate.EqualShares,
  [NoDocumentsOnboardingPromptType.FamilyTrust]:
    HouseholdChatPromptTemplate.FamilyTrust,
  [NoDocumentsOnboardingPromptType.SpecificBequests]:
    HouseholdChatPromptTemplate.SpecificBequests,
  [NoDocumentsOnboardingPromptType.SurvivingSpouse]:
    HouseholdChatPromptTemplate.SurvivingSpouse,
};

export function mapNoDocumentsPromptToChatTemplate(
  templateId: NoDocumentsOnboardingPromptType | undefined
): HouseholdChatPromptTemplate | undefined {
  return templateId ? noDocumentsPromptToChatTemplate[templateId] : undefined;
}

const COMMUNITY_PROPERTY_STATE_CODES = new Set([
  'AZ',
  'CA',
  'ID',
  'LA',
  'NV',
  'NM',
  'TX',
  'WA',
  'WI',
]);

export function getPropertyLaw(stateCode: string): PropertyLaw {
  return COMMUNITY_PROPERTY_STATE_CODES.has(stateCode.toUpperCase())
    ? 'community property'
    : 'common law';
}
